import { Icon28Play } from '@vkontakte/icons';
import { Tappable, ImageBase, AspectRatio } from '@vkontakte/vkui';
import { useState } from 'react';
import styles from './MessageBubbleAttachVideo.module.css';

interface MessageBubbleAttachVideoProps {
  src: string;
  preview: {
    src: string;
    sizes?: string;
  };
  ratio?: number;
}

export function MessageBubbleAttachVideo(props: MessageBubbleAttachVideoProps) {
  const { preview, src, ratio = 16 / 9 } = props;

  const [opened, setOpened] = useState(false);

  const Wrap = opened
    ? { Component: 'div' }
    : { Component: Tappable, props: { hoverMode: 'opacity', activeMode: 'opacity' } };

  return (
    <AspectRatio ratio={ratio} className={styles.root}>
      <Wrap.Component
        className={styles.in}
        onClick={(e) => {
          e.preventDefault();
          setOpened(true);
        }}
        {...Wrap.props}
      >
        {opened ? (
          <video playsInline controls autoPlay className={styles.img}>
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <>
            <ImageBase {...preview} alt="" className={styles.img} />
            <div className={styles.playButton}>
              <Icon28Play />
            </div>
          </>
        )}
      </Wrap.Component>
    </AspectRatio>
  );
}
